module.exports = __webpack_public_path__ + "img/whatsapp-azul.415334e2.svg";